var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"id":_vm.id,"default-tab":"access_group","tabs":_vm.tabs}})}
var staticRenderFns = []

export { render, staticRenderFns }